import { useMediaQuery, useTheme } from '@mui/material';

export const useIsPhone = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('tablet'));
};
